import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './instructionError.view.html';
import './instructionError.scss';
let InstructionErrorComponent = class InstructionErrorComponent {
    //#endregion
    //#region Methods
    handleRetry() {
        this.retryAction?.();
    }
    handleCancel() {
        this.cancelAction?.();
    }
};
InstructionErrorComponent = __decorate([
    Component({
        bindings: {
            header: '<',
            description: '<',
            retryAction: '&?',
            cancelAction: '&?',
        },
        controllerAs: '$ctrl',
        template,
    })
], InstructionErrorComponent);
export { InstructionErrorComponent };
